export const matchesEnvironment = (env: string): boolean =>
  window.location.hostname.includes(env);
